export interface PbxPhonebookListResponse {
	/** Index of the first contact returned. */
	offset: number
	/** Number of contacts to return. Note that the actual number of returned contacts may be lower. */
	limit: number
	/** Number of contacts that can be returned when offset and limit is not considered. This is to be used for paging through the data. */
	total: number
	/** Array of contacts, see definition below. */
	contacts: PbxPhonebookContact[]
}

export interface PbxPhonebookContact {
	/** Unique ID of the contact */
	_id: string

	/** ID of the customer the entry belongs to */
	customer: string

	/** ID of the employee, if the entry belongs to a single employee, otherwise undefined for shared */
	employee: string | null

	/** Type of contact */
	type: PbxPhonebookContactType

	/** Given name */
	givenName: string | null

	/** Family name */
	familyName: string | null

	/** Company name */
	company: string | null

	/** Title of the person */
	title: string | null

	/** Department of the person */
	department: string | null

	/** List of addresses */
	addresses: PbxPhonebookContactAddress[]

	/** Phone numbers */
	phoneNumbers: PbxPhonebookContactPhoneNumber[]

	/** E-mail addresses */
	emailAddresses: PbxPhonebookContactEmailAddress[]

	/** Optional short number (1-7 digits) that will call this contact. Only available on shared contacts */
	shortNumber: string | null

	/** Notes about the contact */
	notes: string

	/** ID of the picture of the contact, undefined if none */
	picture: string | null

	/** External ID, can be used to reference phonebook contacts from another system */
	externalId: string | null

	/** Search string - added locally */
	search?: string

	/** Display name - added locally */
	name: string | null
}

export interface PbxPhonebookContactAddress {
	/** Type of address */
	type: PbxPhonebookContactAddressType

	/** Street, house number, floor, door */
	street: string

	/** Zip code */
	zip: string

	/** City */
	city: string

	/** State */
	state?: string

	/** ISO3166-2 country code */
	country: string
}

export interface PbxPhonebookContactPhoneNumber {
	/** Number type */
	type: PbxPhonebookContactPhoneNumberType

	/** Phone number in E.164 format */
	number: string
}

export interface PbxPhonebookContactEmailAddress {
	/** Type of email */
	type: PbxPhonebookContactEmailType

	/** E-mail address */
	address: string
}

export enum PbxPhonebookContactType {
	PERSON = 'PERSON',
	COMPANY = 'COMPANY'
}

export enum PbxPhonebookContactAddressType {
	HOME = 'HOME',
	WORK = 'WORK'
}

export enum PbxPhonebookContactPhoneNumberType {
	HOME = 'HOME',
	WORK = 'WORK',
	MOBILE = 'MOBILE',
	MAIN = 'MAIN',
	OTHER = 'OTHER'
}

export enum PbxPhonebookContactEmailType {
	HOME = 'HOME',
	WORK = 'WORK',
	MAIN = 'MAIN',
	OTHER = 'OTHER'
}

export type PbxPhonebookResponse = PbxPhonebookContact

export type PbxPhonebookCreateRequest = Omit<PbxPhonebookContact, '_id'>

export type PbxPhonebookCreateResponse = PbxPhonebookContact

export type PbxPhonebookUpdateRequest = Partial<Omit<PbxPhonebookContact, '_id'>>

export type PbxPhonebookUpdateResponse = PbxPhonebookContact

export interface PbxPhonebookDeleteResponse {
	/** True if the contact was successfully deleted */
	success: boolean
}

export interface PbxPhonebookDeleteAllResponse {
	/** True if the contacts were successfully deleted */
	success: boolean
}

export interface PbxPhonebookUploadResponse {
	/** True if the contacts were successfully deleted */
	success: boolean
}

export interface PbxPhonebookUploadPictureResponse {
	/** True on success */
	succes: boolean
	/** Id of the picture on the image server */
	picture: string
}
